import { addToDataLayer } from '../components/tracking/gtm/utils';

export const SIGNUP_SOURCE = {
  blogAuthor: 'blog-author',
  blogCategory: 'blog-category',
  blogPost: 'blog-post',
  ttdCounties: 'ttd-counties',
} as const;

export async function submit({ email }: { email: string }, signupSource?: string): Promise<void> {
  try {
    const response = await fetch('/api/newsletter/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, signupSource }),
    });

    if (!response.ok) {
      throw new Error('Newsletter signup failed');
    }

    const { emailHash } = await response.json();

    if (emailHash) {
      addToDataLayer({ event: 'newsletter_email_signup', emailHash });
    }
  } catch (error) {
    console.warn('Failed to submit newsletter', error instanceof Error ? error.message : error);
  }
}
